export const REGISTER_URL = '/myaccount.asp#registration';
export const MY_NOTINO_BENEFIT_PAGE = '/mynotino/my-benefits/';

export const STANDARD_MODAL_IMAGE_PATH =
  'https://cdn.notinoimg.com/images/gallery/loyalty/new-vip-modal.jpg';
export const RETINA_MODAL_IMAGE_PATH =
  'https://cdn.notinoimg.com/images/gallery/loyalty/new-vip-modal-retina.jpg';
export const MOBILE_MODAL_IMAGE_PATH =
  'https://cdn.notinoimg.com/images/gallery/loyalty/mobile-vip-modal.jpg';
